<template>
  <v-card
    flat
    tile
    class="pa-0 map-container"
    :data-testid="getTestId('site-map')"
  >
    <div id="map" />
  </v-card>
</template>

<script>
import OpenLayerMap from './OpenLayerMap';
import { getTestId } from '@/utils/testUtils';

export default {
  props: {
    location: {
      type: Array,
      default: () => [127.37957, 36.372795]
    },
    /** 사이트 저장 회전값(도). 수정 모달 진입 시 지도에 반영 */
    rotation: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mapInitTimer: null,
      rotationView: null,
      rotationChangeHandler: null
    };
  },
  watch: {
    location(newVal) {
      if (newVal?.length === 2) {
        OpenLayerMap.addFeature(newVal);
      }
    },
    rotation(newVal) {
      this.applyRotationDegrees(newVal);
    }
  },
  mounted() {
    this.scheduleMapInit();
    OpenLayerMap.addEventListener('ol-map-box', this.handleOlEvent);
  },
  beforeDestroy() {
    this.teardownMap();
  },
  // Vue 2.7 호환
  beforeUnmount() {
    this.teardownMap();
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    },
    addEventListener(name, listener) {
      OpenLayerMap.addEventListener(name, listener);
    },
    removeEventListener(name) {
      OpenLayerMap.removeEventListener(name);
    },
    handleOlEvent(eventType, payload) {
      this.$eventBus.$emit('ol-event', {
        from: 'ol-map',
        type: eventType,
        payload: payload
      });
    },
    scheduleMapInit() {
      if (this.mapInitTimer != null) {
        clearTimeout(this.mapInitTimer);
      }
      this.mapInitTimer = setTimeout(() => {
        this.mapInitTimer = null;
        OpenLayerMap.init(this.location, {
          init: true,
          rotation: this.rotation,
          onMapReady: map => this.attachRotationListener(map)
        });
      }, 500);
    },
    attachRotationListener(map) {
      this.clearRotationListener();
      const view = map?.getView?.();
      if (!view) {
        return;
      }
      this.rotationChangeHandler = () => {
        this.emitRotation(view.getRotation());
      };
      view.on('change:rotation', this.rotationChangeHandler);
      this.rotationView = view;
      this.rotationChangeHandler();
    },
    emitRotation(rotationRadians) {
      this.$emit('get-rotation', rotationRadians);
    },
    applyRotationDegrees(rotationDegrees) {
      if (!OpenLayerMap.map?.getView?.()) {
        return;
      }
      if (rotationDegrees === undefined || rotationDegrees === null) {
        return;
      }
      const radians = (Number(rotationDegrees) * Math.PI) / 180;
      if (!Number.isFinite(radians)) {
        return;
      }
      OpenLayerMap.map.getView().setRotation(radians);
    },
    clearRotationListener() {
      if (this.rotationView && this.rotationChangeHandler) {
        this.rotationView.un('change:rotation', this.rotationChangeHandler);
      }
      this.rotationView = null;
      this.rotationChangeHandler = null;
    },
    teardownMap() {
      if (this.mapInitTimer != null) {
        clearTimeout(this.mapInitTimer);
        this.mapInitTimer = null;
      }
      this.clearRotationListener();
      OpenLayerMap.removeEventListener('ol-map-box');
      OpenLayerMap.destroyMap();
    },
    getCurrentRotation() {
      if (OpenLayerMap.map?.getView?.()) {
        return OpenLayerMap.map.getView().getRotation();
      }
      return 0;
    },
    setRotation(rotation) {
      if (OpenLayerMap.map?.getView?.()) {
        OpenLayerMap.map.getView().setRotation(rotation);
      }
    }
  }
};
</script>

<style scoped>
.map-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
}

#map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
  margin: 0;
  padding: 0;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  /* color: #2c3e50; */
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: var(--v-text-base);
}
#nav a.router-link-exact-active {
  color: var(--v-primary-base);
}
</style>
